<template>
    <div class="filtre date">
        <label for="daterange">{{ $t("message.recherche_dates") }}</label>
        <input id="daterange" readonly>
    </div>
</template>
<script>
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeFR from 'air-datepicker/locale/fr';
export default {
  name: 'FiltreDates',  
  data: function() {
    return { 
        selected: this.selectedFilters,
    }
  },
  props: ['selectedFilters', 'api'], 
  methods : {
    initDaterange(selected) {
      let startDate = new Date();
      new AirDatepicker('#daterange', {
          locale: localeFR,
          startDate,
          range: true,
          buttons: ['clear'],
          multipleDatesSeparator: ' > ',
          onSelect ({date}) {
            selected['date'] = date;
          }
      })
    },  
  },
  mounted() {
    this.initDaterange(this.selected);
  },
}
</script>
<style scoped>
button { display: block; width:100%; }
</style> 